import Tag from "@/components/Tag";
import {
  getOrderStatusDisplayLabel,
  getOrderStatusTagExtras,
  getOrderStatusTagStyle,
  getOrderStatusTagType
} from "./orderPresentation";

interface ScreeningOrderStatusTagProps {
  status: string | null | undefined;
  firstName?: string | null;
  size?: "small" | "medium" | "large";
}

export default function ScreeningOrderStatusTag({ status, firstName, size = "small" }: ScreeningOrderStatusTagProps) {
  const extras = getOrderStatusTagExtras(status, firstName);

  return (
    <Tag
      tagType={getOrderStatusTagType(status)}
      tagStyle={getOrderStatusTagStyle(status)}
      size={size}
      iconName={extras?.iconName}
      tooltipText={extras?.tooltipText}
    >
      {getOrderStatusDisplayLabel(status)}
    </Tag>
  );
}
